import { __decorate } from "tslib";
import { field } from "@simonbackx/simple-encoding";
import { Group } from '../Group';
import { Member } from './Member';
import { Registration } from "./Registration";
export class RegistrationWithMember extends Registration {
}
__decorate([
    field({ decoder: Member })
], RegistrationWithMember.prototype, "member", void 0);
__decorate([
    field({ decoder: Group })
], RegistrationWithMember.prototype, "group", void 0);
//# sourceMappingURL=RegistrationWithMember.js.map